import { observer } from 'mobx-react-lite'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

interface AppBarContainerCloseButtonProps {
   callback: () => void
}

export const AppBarContainerCloseButton = observer(function AppBarContainerCloseButton(props: AppBarContainerCloseButtonProps) {
   return <IconButton key="close" aria-label="Close" color="inherit" onClick={props.callback} sx={{ marginRight: '-12px' }}>
      <CloseIcon />
   </IconButton>
})
